import BaseClass from "./BaseClass";
import Helper from "./Helper";
import PaginationWithNumbers from "./pagination/PaginationWithNumbers";
import Country from "./Country";
import Lazyloading from "./Lazyloading";

const defaultOptions = {};

export default class Filter extends BaseClass {

    constructor(options)
    {
        super(options, defaultOptions);

        this.appliedFilters = {};

        this.init();
    }

    init()
    {
        let classInstance = this;

        $(document).ready(function () {
            classInstance.filterFromSessionSetValues();

            if ($('[data-masonryentities]').length > 0) {
                classInstance.initDependencies(true);
                classInstance.initPriceDependencies();
            }

            $('[data-savefiltergroup="facilities"]').prop('disabled', false);

            // Init toggle more wizard options click
            if ($('[data-togglemoreoptions]').length > 0) {
                $('[data-togglemoreoptions]').click(function () {
                    let categoryName = $(this).data('togglemoreoptions');

                    $('[data-moreoptions="' + categoryName + '"]').slideToggle();
                    $(this).toggleClass('active');
                });
            }

            /** PRICE SLIDER */
            if ($("#price-slider").length > 0) {
                var wrapper = $('[data-pricesliderwrapper]').first();
                var minHolder = wrapper.find('[data-priceminselect]').first();
                var maxHolder = wrapper.find('[data-pricemaxselect]').first();
                var minShow = wrapper.parents('[data-filterwrapper]').find('[data-minshow]').first();
                var maxShow = wrapper.parents('[data-filterwrapper]').find('[data-maxshow]').first();

                // Origin min/max
                var minValue = minHolder.data('priceminselect');
                var maxValue = maxHolder.data('pricemaxselect');

                $("#price-slider").slider({
                    range: true,
                    animate: "slow",
                    min: parseInt(minValue), // ParseInt so that the value is always round to lower (84,6 to 84)
                    max: parseInt(maxValue + 1),  // (+ 1, because the step is taken from min, so if the min is x.60 and max x.0 then the max is not taken at end)
                    values: [
                        (parseFloat(minValue) === parseFloat(minHolder.val()))? parseInt(minValue) : minHolder.val() ,
                        (parseFloat(maxValue) === parseFloat(maxHolder.val()))? parseInt(maxValue + 1) : maxHolder.val() // Same as max above
                    ],
                    step: 1,
                    slide: function (e, a) {
                        // Selected min/max
                        let min = a.values[0];
                        let max = a.values[1];

                        minHolder.val(min);
                        maxHolder.val(max);

                        var options = $(this).slider('option');

                        minShow.html(wrapper.data('currency') + min.toFixed(2).toString().replace('.', ','));
                        maxShow.html(wrapper.data('currency') + max.toFixed(2).toString().replace('.', ','));

                        // Highlight columns in selected range
                        classInstance.highlightColumns(options.min, options.max, min, max, 'averageprice')
                    }
                });

                $('#price-slider').draggable()
            }

            /** SAVING THE FILTER */
            let entityID = $('[data-entity-id]').data('entityId');
            let entityType = $('[data-entity-model]').data('entityModel');

            $('[data-savefiltergroup]').click(function () {
                let filterRoot = $(this).parents('[data-filterroot]')[0];

                var newFilters = {};
                newFilters.names = [];
                var optionsSetCount = classInstance.saveFilters(filterRoot, newFilters);

                if (optionsSetCount > 0) {
                    if (Helper.isMobileOrLower()) {
                        $('[data-togglemodal="all"]').parent().addClass('has_items');
                    } else {
                        $('[data-togglemodal="' + $(this).data('savefiltergroup') + '"]').parent().addClass('has_items');
                    }
                } else {
                    if (Helper.isMobileOrLower()) {
                        $('[data-togglemodal="all"]').parent().removeClass('has_items');
                    } else {
                        $('[data-togglemodal="' + $(this).data('savefiltergroup') + '"]').parent().removeClass('has_items');
                    }
                }

                $('[data-togglemodal="' + $(this).data('savefiltergroup') + '"]').trigger('click');

                if (Helper.isMobileOrLower()) {
                    window.showFilterModalRespo(false);
                } else {
                    $('[data-dim="filter-modal"]').hide();
                }

                if ($('[data-loader]').length > 0) {
                    $('[data-loader]').show();
                    $('[data-entity-insert]').hide();
                }

                $('body').css('overflow', 'scroll');

                // Filter entities by saved values in sessions
                classInstance.filterFromSessionSetValues();

                $.ajax({
                    method: 'POST',
                    url: window.location.origin + "/api/get/filter/entities-facilities",
                    data: {
                        'entityID': entityID,
                        'entityType' : entityType,
                        'appliedFilters': classInstance.appliedFilters,
                        '_token': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    success: function (data) {
                        window.galleries = {};

                        if (JSON.parse(data.filterCount) === 0) {
                            $('[data-filter-zero-results]').show();
                        } else {
                            $('[data-filter-zero-results]').hide();
                        }

                        $('[data-filtercount]').html(JSON.parse(data.filterCount));
                        $('[data-entity-insert]').html(data.view);
                        $('[data-filterroot="sort"]').find('a.active').click();

                        classInstance.initDependencies();

                        if ($('[data-loader]').length > 0) {
                            $('[data-loader]').hide();
                        }

                        if ( $('[data-entity-insert]').length > 0) {
                            $('[data-entity-insert]').show();
                        }

                        // Get the root for filter (filter modal)
                        classInstance.updateSessions(newFilters.names);
                        classInstance.updatePriceDependencies();
                        window.urlClass.addOrReplaceActiveParam(classInstance.appliedFilters, 'storedMasonryFilters');

                        window.json_data = JSON.parse(data.json_data);
                        window.json_center_map = JSON.parse(data.map_center);

                        if (!JSON.parse(data.willBeSecondPage)) {
                             window.updateMap();
                        }
                    }
                });
            });

            /** CLEARING THE FILTER */
            $('[data-clearfilter]').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var filter = $(this).data('clearfilter')
                var filterGroup = $(this).data('filtergroup');
                var filterNames = [];

                if (filter === 'all') {
                    if (filterGroup === 'all') {
                        classInstance.appliedFilters = {};
                        filterNames = 'all';
                        // Uncheck all checkboxes in modals
                        $('[data-filterroot]').find('input[type="checkbox"]:checked').prop('checked', false);
                        classInstance.resetSlider();
                    } else {
                        let filterRoot = $('[data-filterroot="'+ filterGroup +'"]')[0];

                        // Find all filter categories in the modal
                        $(filterRoot).find('[data-filterwrapper]').each(function () {
                            var filterName = $(this).data('filterwrapper');
                            filterNames.push(filterName);
                            // Reset filters in modal
                            classInstance.appliedFilters[filterName] = {};

                            // Uncheck all checkboxes in the modal
                            $(this).find('input[type="checkbox"]:checked').prop('checked', false);

                            if (filterName === 'averageprice') {
                                classInstance.resetSlider();
                            }
                        });
                    }

                    $('[data-togglemodal="' + filterGroup + '"]').parent().removeClass('has_items');
                } else {
                    filterNames.push(filter);
                    classInstance.appliedFilters[filter] = {};
                    $('[data-filterwrapper="' + filter + '"] input[type="checkbox"]:checked').prop('checked', false);

                    if (filter === 'averageprice') {
                        classInstance.resetSlider();
                    }

                    if (classInstance.filterGroupEmpty(filterGroup)) {
                        $('[data-togglemodal="' + filterGroup + '"]').parent().removeClass('has_items');
                    }
                }

                classInstance.clearSessions(filterNames, classInstance.appliedFilters);
                window.urlClass.deleteActiveParams(filterNames, 'storedMasonryFilters');
            });


            /** FILTER MODAL */
            if ($('.filter__modal').length > 0) {
                // If modal is active and user click besides it, it will close
                $(document).mousedown(function (e) {
                    var modal = $('.filter__modal.active').first();
                    var modalToggle = $('[data-togglemodal="' + $(modal).data('filterroot') + '"]');
                    if (modal !== undefined) {
                        if ((!$(modal).is(e.target) && $(modal).has(e.target).length === 0) &&
                        (!$(modalToggle).is(e.target) && $(modalToggle).has(e.target).length === 0)) {
                            if (!Helper.isMobileOrLower() || $(modal).attr('id') == 'sort_modal') {
                                $(modal).hide();
                                $(modal).removeClass('active');
                                modalToggle.parent().removeClass('active');
                            }

                            classInstance.clearNotSelectCheckboxes(modal);
                            $('[data-dim="filter-modal"]').hide();
                            $('body').css('overflow', 'scroll');
                        }
                    }
                });
            }

            /** SEARCH */
            if ($('[data-filtersearch]').length > 0) {
                var langCode = $('meta[name="country"]').attr('content');

                // Wizards filter search
                $('[data-filtersearch]').on('keyup', function () {
                    var val = $.trim(this.value);

                    if (langCode === 'ru') {
                        val = Helper.cyrillicToLatin(val);
                    }

                    val = val.toLowerCase();
                    var searchRoot = $('[data-filterroot="' + $(this).data('filtersearch') + '"]');

                    // Toggle all more options blocks to visible if they are not
                    searchRoot.find('[data-togglemoreoptions]:not(.active)').trigger('click');

                    if (val) {
                        var optionsToHide = $(searchRoot.find('[data-itemsearchtext][data-itemsearchtext!="' + val + '"]'));
                        var optionsToShow = $(searchRoot.find('[data-itemsearchtext*="' + val + '"]'));

                        optionsToHide.parent().hide();
                        optionsToShow.parent().show();

                        // Check if in wrapper for hide options are all the options hidden, if so, then hide the whole category as well
                        optionsToHide.parents('[data-filterwrapper]').each(function () {

                            var options = $(this).find('[data-itemsearchtext]');
                            var hiddenCount = 0;

                            // Count hidden options in category
                            $(options).each(function () {
                                if ($(this).is(':hidden')) {
                                    hiddenCount += 1;
                                }
                            });

                            if (options.length == hiddenCount) {
                                $(this).parent().hide();
                            }
                        });
                    } else {
                        var optionsToShow =  searchRoot.find('[data-itemsearchtext]');
                        optionsToShow.parent().show();
                    }

                    optionsToShow.parents('[data-filterwrapper]').parent().show();
                });
            }
        });
    }

  /**
   * Will filter entities by values from sessions. (initial filtering)
   */
    filterFromSessionSetValues()
    {
        var classInstance = this;

        $('[data-togglemodal]').each(function () {
          // If there is filter group that has set any filters from sessions, pull them and filter the entities
            if ($(this).parent().hasClass('has_items')) {
                let filterRoot = $('[data-filterroot="' + $(this).data('togglemodal') + '"]').first();

                classInstance.saveFilters(filterRoot, {});
            }
        });
    }

  /**
   * Will save filters from given filter root to instance storage and will apply them.
   *
   * @param {Element} filterRoot filter root under which we want to save the filters
   * @param {Object} newFilters passed by reference, will add filter names under .names
   *
   * @returns {BigInteger} count of applied filters
   */
    saveFilters(filterRoot, newFilters)
    {
        if (newFilters.names === undefined) {
            newFilters.names = [];
        }

        var classInstance = this;
        var optionsSetCount = 0;

        // Find all filter categories in this modal
        $(filterRoot).find('[data-filterwrapper]').each(function () {
            var filterName = $(this).data('filterwrapper');
            newFilters.names.push(filterName);
            classInstance.appliedFilters[filterName] = [];

            if (filterName !== 'averageprice') {
                // Loop through every option checked and add its value to the applied filters var
                $(this).find('input[type="checkbox"]:checked').each(function () {
                    classInstance.appliedFilters[filterName].push($(this).val());
                    optionsSetCount += 1;
                });
            } else {
                var wrapper = $('[data-pricesliderwrapper]').first();
                var minHolder = wrapper.parents('[data-filterwrapper]').find('[data-priceminselect]').first();
                var maxHolder = wrapper.parents('[data-filterwrapper]').find('[data-pricemaxselect]').first();

                if (minHolder.val() > minHolder.data('priceminselect') || maxHolder.val() < maxHolder.data('pricemaxselect')) {
                    classInstance.appliedFilters[filterName].push(parseFloat($(minHolder).val()));
                    classInstance.appliedFilters[filterName].push(parseFloat($(maxHolder).val()));
                    optionsSetCount += 2;
                }
            }
        });

        return optionsSetCount;
    }

  /**
   * Will return empty if there is no option set in filter group.
   *
   * @param {String} filterGroup filter group representation
   */
    filterGroupEmpty(filterGroup)
    {
        var classInstance = this;
        let filterRoot = $('[data-filterroot="'+ filterGroup +'"]').first();
        var optionsSetCount = 0;

        // Find all filter categories in given filter group
        $(filterRoot).find('[data-filterwrapper]').each(function () {
            var filterName = $(this).data('filterwrapper');
            optionsSetCount += (classInstance?.appliedFilters[filterName]?.length ?? 0);
        });

        return optionsSetCount == 0;
    }

  /**
   * Resets the slider/sliders to its initial min/max values.
   */
    resetSlider()
    {
        var classInstance = this;

        $('#price-slider').each(function () {
            let wrapper = $('[data-pricesliderwrapper]').first();
            let minHolder = wrapper.find('[data-priceminselect]').first();
            let maxHolder = wrapper.find('[data-pricemaxselect]').first();
            let minShow = wrapper.parents('[data-filterwrapper]').find('[data-minshow]').first();
            let maxShow = wrapper.parents('[data-filterwrapper]').find('[data-maxshow]').first();

            let options = $(this).slider('option');

            $(this).slider('values', [ options.min, options.max ]);

            minHolder.val(options.min);
            maxHolder.val(options.max);

            minShow.html(wrapper.data('currency') + options.min.toFixed(2).toString().replace('.', ','));
            maxShow.html(wrapper.data('currency') + options.max.toFixed(2).toString().replace('.', ','));

            classInstance.highlightColumns(options.min, options.max, options.min, options.max, $(wrapper).data('pricesliderwrapper'))
        });
    }

  /**
   * Will initialize slider columns for given filter, based on min/max values.
   *
   * @param {Float} minValue min value, that can be selected on slider
   * @param {Float} maxValue max value, that can be selected on slider
   * @param {String} filterName for which filter
   */
    initSliderColumns(minValue, maxValue, filterName)
    {
        let classInstance = this;
        let columnPercentWidth = parseInt($('[data-columnpercent]').data('columnpercent'));
        let columnsCount = 100 / columnPercentWidth;

        minValue = parseFloat(minValue);
        maxValue = parseFloat(maxValue);
        let differenceValue = maxValue - minValue;

        let columnEntitiesCount = [];
        for (let i = 0; i < columnsCount + 1; i++) {
            columnEntitiesCount[i] = 0;

            let lowerPercentage = i * columnPercentWidth;
            let higherPercentage = lowerPercentage + columnPercentWidth;
            let lower = minValue + classInstance.getSliderValue(lowerPercentage, differenceValue);
            let higher = minValue + classInstance.getSliderValue(higherPercentage, differenceValue);

            $('[data-masonryentities] [data-price-slider-element]').each(function () {
                let entityValue = parseFloat($(this).data(filterName));

                if (parseFloat(entityValue.toFixed(2)) >= parseFloat(lower.toFixed(2)) && parseFloat(entityValue.toFixed(2)) < parseFloat(higher.toFixed(2))) {
                    columnEntitiesCount[i]++;
                }
            });
        }

        let maxCount = Math.max(...columnEntitiesCount);

        if (maxCount != 0) {
            for (let i = 0; i < columnEntitiesCount.length; i++) {
                if (columnEntitiesCount[i] == maxCount) {
                    $('[data-slidercolumn="' + i + '"]').children().css('height', '100%');
                } else {
                    let heightPercentage = 100 * columnEntitiesCount[i] / maxCount;
                    $('[data-slidercolumn="' + i + '"]').children().css('height', heightPercentage + '%');
                }
            }
        }
    }

  /**
   * This function will highlight those columns that are within selected range.
   *
   * @param {Float} min origin range start
   * @param {Float} max origin range end
   * @param {Float} minValue selected range start
   * @param {Float} maxValue selected range end
   * @param {String} filterName name of the filter under which is the slider
   * @param {Boolean} onLoad
   */
    highlightColumns(min, max, minValue, maxValue, filterName, onLoad = false)
    {
        let classInstance = this;
        min = parseFloat(min);
        max = parseFloat(max);
        minValue = parseFloat(minValue);
        maxValue = parseFloat(maxValue);
        let differenceValue = max - min;

        let minPercentage = classInstance.getSliderPercentageFromValue(minValue - min, differenceValue);
        let maxPercentage = classInstance.getSliderPercentageFromValue(maxValue - min, differenceValue);

        let wrapper = $('[data-filterwrapper="' + filterName + '"]');
        let columnPercentWidth = parseInt(wrapper.find('[data-columnpercent]').data('columnpercent'));

        for (let i = 0; i < 100 / columnPercentWidth + 1; i++) {
            let percentageLow = i * columnPercentWidth;
            let percentageHigh = i * columnPercentWidth + columnPercentWidth;

            // If the columns percentage is in given value range
            if ((percentageLow >= minPercentage && percentageLow <= maxPercentage)
            || (percentageHigh >= minPercentage && percentageHigh <= maxPercentage)) {
                let entitiesCount = 0;
                let countEntities = true;

                // Get lower value of the column
                let lowerValue = min;
                if (parseFloat(minPercentage.toFixed(2)) >= parseFloat(percentageLow.toFixed(2))) {
                    // If the slider handle is in the column calculate the value by its position
                    let lowOffset = minPercentage - percentageLow;
                    lowerValue += classInstance.getSliderValue(percentageLow + lowOffset, differenceValue);
                } else {
                    lowerValue += classInstance.getSliderValue(percentageLow, differenceValue);
                    countEntities = false;
                }

                // Get higher value of the column
                let higherValue = min;
                if (parseFloat(maxPercentage.toFixed(2)) <= parseFloat(percentageHigh.toFixed(2))) {
                    // If the slider handle is in the column calculate the value by its position
                    let highOffset = percentageHigh - maxPercentage;
                    higherValue += classInstance.getSliderValue(percentageHigh - highOffset, differenceValue);
                    countEntities = true;
                } else {
                    higherValue += classInstance.getSliderValue(percentageHigh, differenceValue);
                }

                // If there is need for counting the entities in column (so if any handle is in column value range)
                if (countEntities) {
                    lowerValue = parseFloat(lowerValue.toFixed(2));
                    higherValue = parseFloat(higherValue.toFixed(2));

                    if (lowerValue === higherValue) {
                        lowerValue -= 1;
                    }

                    if (onLoad) {
                        // Loop through masonry entities
                        $('[data-masonryentities] [data-price-slider-element]').each(function () {
                            let entityValue = parseFloat(parseFloat($(this).data(filterName)).toFixed(2));

                            // Check if current entity is in value range
                            if (entityValue >= lowerValue && entityValue <= higherValue) {
                                entitiesCount++;
                            }
                        });
                    } else {
                        let fillElement = wrapper.find('[data-slidercolumn="' + i + '"]').find('.filter__slider__columns__column__fill');

                        if ($(fillElement).height() !== 0) {
                            entitiesCount++;
                        }
                    }

                    // If the columns percentage is in given value range
                    // And if there is any entity in column range or column range modified by slider handle
                    if (entitiesCount > 0) {
                        wrapper.find('[data-slidercolumn="' + i + '"]').addClass('active');
                    } else {
                        wrapper.find('[data-slidercolumn="' + i + '"]').removeClass('active');
                    }
                } else {
                    wrapper.find('[data-slidercolumn="' + i + '"]').addClass('active');
                }
            } else {
                wrapper.find('[data-slidercolumn="' + i + '"]').removeClass('active');
            }

            if (percentageLow === 0 && minPercentage !== 0) {
                wrapper.find('[data-slidercolumn="' + i + '"]').removeClass('active');
            }
        }
    }

  /**
   * Will get stored values for given filters and will call url via AJAX, that will update them in sessions.
   *
   * @param {String[]} filtersToUpdate array of filters that should be updated in sessions
   */
    updateSessions(filtersToUpdate)
    {
        var classInstance = this;
        var filterValues = {};

        // Fetch stored filters for given filters
        for (var i = 0; i < filtersToUpdate.length; i++) {
            let filterName = filtersToUpdate[i];
            if (classInstance.appliedFilters[filterName].length > 0) {
                filterValues[filterName] = classInstance.appliedFilters[filterName];
            } else {
                // If there is nothing set under the filter, clear it
                filterValues[filterName] = null;
            }
        }

        $.ajax({
            method: 'POST',
            url: window.location.origin + "/filter/update-sessions",
            data: {
                'valuesToStore': filterValues,
                '_token': $('meta[name="csrf-token"]').attr('content')
            }
        });
    }

  /**
   * Will call AJAX that will clear given filters from sessions.
   *
   * @param {String[]} filtersToClear filters names that should be cleared
   * @param appliedFilters
   */
    clearSessions(filtersToClear, appliedFilters)
    {
        var classInstance = this;

        if ( $('[data-entity-insert]').length > 0) {
            $('[data-entity-insert]').hide();
        }

        if ($('[data-loader]').length > 0) {
            $('[data-loader]').show();
        }

        $('body').css('overflow', 'scroll');

        let entityID = $('[data-entity-id]').data('entityId');
        let entityType = $('[data-entity-model]').data('entityModel');

        $.ajax({
            method: 'POST',
            url: window.location.origin + "/api/get/filter/entities-facilities",
            data: {
                'filtersToClear': filtersToClear,
                'entityID': entityID,
                'entityType': entityType,
                'appliedFilters': appliedFilters,
                '_token': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',
            success: function (data) {
                window.galleries = {};

                if (JSON.parse(data.filterCount) === 0) {
                    $('[data-filter-zero-results]').show();
                } else {
                    $('[data-filter-zero-results]').hide();
                }

                // Save entities with its available facilities to instance variable for filter checking
                $('[data-filtercount]').html(JSON.parse(data.filterCount));
                $('[data-entity-insert]').html(data.view);
                $('[data-filterroot="sort"]').find('a.active').click();

                classInstance.initDependencies();

                if ($('[data-loader]').length > 0) {
                    $('[data-loader]').hide();
                }

                if ( $('[data-entity-insert]').length > 0) {
                    $('[data-entity-insert]').show();
                }

                window.json_data = JSON.parse(data.json_data);
                window.json_center_map = JSON.parse(data.map_center);

                if (!JSON.parse(data.willBeSecondPage)) {
                    window.updateMap();
                }

                classInstance.initPriceDependencies();
            }
        });
    }

  /**
   * This function will get value from max given value based on given percentage (max is 100%). 0% is 0.
   *
   * @param {BigInteger} percentage percentage from which we want to get value
   * @param {Float} maxValue what is 100% value
   *
   * @returns {Float} Value for given percentage
   */
    getSliderValue(percentage, maxValue)
    {
        return maxValue * percentage / 100;
    }

  /**
   * This function will return percentage for given value
   *
   * @param {Float} value value from which we want to get percentage
   * @param {String} maxValue what is 100% value
   *
   * @returns {Float} Percentage for given value
   */
    getSliderPercentageFromValue(value, maxValue)
    {
        return 100 * value / maxValue;
    }

  /**
   * Clear selection of checkboxes that has not been saved yes. (used in modal closing)
   *
   * @param {Element} filterRoot under which root check checkbox
   */
    clearNotSelectCheckboxes(filterRoot)
    {
        var classInstance = this;

        $(filterRoot).find('[data-filter]').each(function () {
            var filterName = $(this).data('filter');

            if (!Array.isArray(classInstance.appliedFilters[filterName] ?? null)
                || !classInstance.appliedFilters[filterName].includes($(this).val())
            ) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });
    }

  /**
   * Function that inits dependencies
   *
   * @param {Boolean} onLoad
   */
    initDependencies(onLoad = false)
    {
        if (!onLoad) {
            new PaginationWithNumbers();
            new Country();
            new Lazyloading();
            $('[data-readmore]').readmore();
        }

        Helper.initFollowablePopups(document);
        window.initMapDependencies();
    }

    /**
     * Function that inits price dependencies
     */
    initPriceDependencies() {
        let classInstance = this;
        // Initialize slider columns with highliting them
        let wrapper = $('[data-pricesliderwrapper]').first();
        let minHolder = wrapper.find('[data-priceminselect]').first();
        let maxHolder = wrapper.find('[data-pricemaxselect]').first();

        // Origin min/max
        let minValue = minHolder.data('priceminselect');
        let maxValue = maxHolder.data('pricemaxselect');

        classInstance.initSliderColumns(minValue, maxValue, 'averageprice');
        classInstance.highlightColumns(minValue, maxValue, minHolder.val(), maxHolder.val(), $(wrapper).data('pricesliderwrapper'), true);
    }

    /**
     * Function that updates price dependencies
     */
    updatePriceDependencies() {
        let classInstance = this;
        // Initialize slider columns with highliting them
        let wrapper = $('[data-pricesliderwrapper]').first();
        let minHolder = wrapper.find('[data-priceminselect]').first();
        let maxHolder = wrapper.find('[data-pricemaxselect]').first();

        // Origin min/max
        let minValue = minHolder.data('priceminselect');
        let maxValue = maxHolder.data('pricemaxselect');

        classInstance.updateSliderColumns(minValue, maxValue, 'averageprice');
        classInstance.highlightColumns(minValue, maxValue, minHolder.val(), maxHolder.val(), $(wrapper).data('pricesliderwrapper'), true);
    }

    /**
     * Will update slider columns for given filter, based on min/max values.
     *
     * @param {Float} minValue min value, that can be selected on slider
     * @param {Float} maxValue max value, that can be selected on slider
     * @param {String} filterName for which filter
     */
    updateSliderColumns(minValue, maxValue, filterName)
    {
        let classInstance = this;
        let columnPercentWidth = parseInt($('[data-columnpercent]').data('columnpercent'));
        let columnsCount = 100 / columnPercentWidth;

        minValue = parseFloat(minValue);
        maxValue = parseFloat(maxValue);
        let differenceValue = maxValue - minValue;

        let columnEntitiesCount = [];
        for (let i = 0; i < columnsCount + 1; i++) {
            columnEntitiesCount[i] = 0;

            let lowerPercentage = i * columnPercentWidth;
            let higherPercentage = lowerPercentage + columnPercentWidth;
            let lower = minValue + classInstance.getSliderValue(lowerPercentage, differenceValue);
            let higher = minValue + classInstance.getSliderValue(higherPercentage, differenceValue);

            $('[data-masonryentities] [data-price-slider-element]').each(function () {
                let entityValue = parseFloat($(this).data(filterName));

                if (parseFloat(entityValue.toFixed(2)) >= parseFloat(lower.toFixed(2)) && parseFloat(entityValue.toFixed(2)) < parseFloat(higher.toFixed(2))) {
                    columnEntitiesCount[i]++;
                }
            });
        }

        let maxCount = Math.max(...columnEntitiesCount);

        if (maxCount !== 0) {
            for (let i = 0; i < columnEntitiesCount.length; i++) {
                if (columnEntitiesCount[i] === maxCount) {
                    $('[data-slidercolumn="' + i + '"]').children().css('height', '100%');
                }
            }
        }
    }
}
